import React from 'react';
import styled from 'styled-components';

// tslint:disable-next-line:variable-name
const SLightbox = styled.div<{}>(() => ({
  position: 'fixed',
  backgroundColor: 'rgba(255,255,255, 0.75)',
  width: '100%',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,
}));

export default class Lightbox extends React.Component {
  public render() {
    return (
      <SLightbox>{this.props.children}</SLightbox>
    );
  }
}
